<div class="login-body">
    <div class="login-panel ui-fluid">
        <div class="login-container--overlay"></div>
        <div class="ui-g login-container" style="padding-bottom: 10px;">
            <div class="login-container--content">
                <form [formGroup]="loginForm">
                    <div class="ui-g-12">
                        <input type="text" autocomplete="off"
                            class="ui-inputtext ui-corner-all ui-state-default ui-widget" placeholder="Email"
                            formControlName="email">
                    </div>
                    <div class="ui-g-12">
                        <input type="password" autocomplete="off"
                            class="ui-inputtext ui-corner-all ui-state-default ui-widget" placeholder="Password"
                            formControlName="password">
                    </div>
                    <div class="ui-g-12 button-container">
                        <button pButton type="button" label="Sign In" class="p-button-success"
                            (click)="tryLogin()"></button>
                    </div>
                </form>
                <div>
                    <a routerLink="/forgot-password"> Forgot my Password </a>
                </div>
            </div>
        </div>

        <p style="margin-left: -17px;position: inherit;">Not yet registered?<a href="" [routerLink]="['/signup']">
                Register here </a></p>

        <div class="ui-g login-container" style="padding-top: 10px;">
            <div class="ui-g-12 button-container">
                <button pButton type="button" label="Google" icon="pi pi-google" iconPos="left"
                    class="p-button-danger p-button-raised p-button-rounded" (click)="tryGoogleLogin()"></button>
            </div>
        </div>
    </div>
</div>

<!-- activate profile modal -->
<!-- <p-confirmDialog appendTo="body" [style]="{width: '50vw'}"></p-confirmDialog> -->

<!-- email verification overlay -->
<p-dialog header="Email Verification" [(visible)]="showVerficationOverlay" [modal]="true" width="400">
    <span>You have not verified your email address yet. A new verification email has been sent to
        <strong>{{ email }}</strong>.
        Please verify your email address by clicking the link in the sent email.</span>
    <p-footer>
        <button type="button" pButton icon="pi pi-replay" (click)="resendEmail()" label="Resend"></button>
        <button type="button" pButton icon="pi pi-caret-right" (click)="continue()" label="Continue"
            class="ui-button-secondary"></button>
    </p-footer>
</p-dialog>